import { useCollection, useDocument } from '@nandorojo/swr-firestore';
import {
  CollectionPath,
  SettingCollectionPath,
} from '@typings/collections.enum';
import { Ijukebox, IJukeboxItem } from '@typings/setting/jukebox.interface';
import React, { useState } from 'react';
import styled from 'styled-components';
import AllPlayList from './AllPlayList';
import MiniPlayer from '../components/MiniPlayer';
import { scrollbarHide } from '@styles/variants/scrollbar';

const JukeboxContainer = styled.div`
  grid-area: musicplayer;
  border-radius: 8px;
  overflow: auto;
  ${scrollbarHide}
`;

type Props = {
  style?: React.CSSProperties;
  size?: 'md' | 'sm';
};

function MainhomeMusicPlayer({ style, size = 'md' }: Props) {
  const { data: playlist } = useCollection<IJukeboxItem>(
    CollectionPath.JUKEBOX,
    { listen: true, orderBy: ['order', 'asc'] },
  );

  const { data: jukebox } = useDocument<Ijukebox>(
    SettingCollectionPath.JUKEBOX,
    { listen: true },
  );

  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <JukeboxContainer
      style={{
        backgroundColor: jukebox?.themeSet?.backgroundColor,
        color: jukebox?.themeSet?.textColor,
        border: `1px solid ${jukebox?.themeSet?.lineColor}`,
        ...style,
      }}
    >
      <MiniPlayer
        size={size}
        currentIndex={currentIndex}
        onIndexChange={setCurrentIndex}
      />

      <AllPlayList
        playlist={playlist || []}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        jukeboxData={jukebox}
        style={{ padding: `0 16px 16px 16px` }}
      />
    </JukeboxContainer>
  );
}

export default MainhomeMusicPlayer;
